'use client';

import { Hero } from '@/components/NewHeader/Hero';
import { NavBar } from '@/components/NewHeader/NavBar';
import { SideMenu } from '@/components/NewHeader/SideMenu';
import { TopHeader } from '@/components/NewHeader/TopHeader';
import { useHeaderScroll } from '@/components/NewHeader/useHeaderScroll';
import { useLoadPromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';
import { cn } from '@/lib/utils';

export function HeaderContainer() {
  const { isActive, setIsHover, isHome } = useHeaderScroll();
  useLoadPromotionalCatalogs();

  return (
    <>
      <header
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className={cn(
          'fixed top-0 inset-x-0 z-50 transition-colors duration-300 text-white',
          isActive && 'bg-white/[90] text-current',
          !isHome && 'sticky mb-8',
        )}>
        <SideMenu />
        <TopHeader />
        <BorderHr />
        <NavBar />
        <BorderHr />
      </header>

      <Hero />
    </>
  );
}

function BorderHr() {
  const { isActive } = useHeaderScroll();

  return (
    <hr
      className={cn(
        'border-t border-gray-200 lg:border-white/20 hidden lg:block',
        isActive && 'lg:border-gray-200',
      )}
    />
  );
}
